/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Access_DeniedInputs */

const en_document_access_denied = /** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request Denied`)
};

const id_document_access_denied = /** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan Ditolak`)
};

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const es_document_access_denied = en_document_access_denied;

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const fr_document_access_denied = en_document_access_denied;

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const de_document_access_denied = en_document_access_denied;

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const ja_document_access_denied = en_document_access_denied;

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const zh_document_access_denied = en_document_access_denied;

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const ar_document_access_denied = en_document_access_denied;

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const it_document_access_denied = en_document_access_denied;

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const ru_document_access_denied = en_document_access_denied;

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const pt_document_access_denied = en_document_access_denied;

/** @type {(inputs: Document_Access_DeniedInputs) => LocalizedString} */
const ko_document_access_denied = en_document_access_denied;

/**
* | output |
* | --- |
* | "Request Denied" |
*
* @param {Document_Access_DeniedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const document_access_denied = /** @type {((inputs?: Document_Access_DeniedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Access_DeniedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_document_access_denied(inputs)
	if (locale === "es") return es_document_access_denied(inputs)
	if (locale === "fr") return fr_document_access_denied(inputs)
	if (locale === "de") return de_document_access_denied(inputs)
	if (locale === "ja") return ja_document_access_denied(inputs)
	if (locale === "zh") return zh_document_access_denied(inputs)
	if (locale === "ar") return ar_document_access_denied(inputs)
	if (locale === "id") return id_document_access_denied(inputs)
	if (locale === "it") return it_document_access_denied(inputs)
	if (locale === "ru") return ru_document_access_denied(inputs)
	if (locale === "pt") return pt_document_access_denied(inputs)
	return ko_document_access_denied(inputs)
});